import {
  ProcessingItemState,
  useActionButtonContext,
} from '@aibees/elephant/context/action-button-context';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { SaveRecordAction, useTrackEvents } from '@aibees/elephant/hooks';
import { usePersonalityAnalysisStatus } from '@aibees/elephant/hooks/people/use-personality-analysis-status';
import { useSaveRecord } from '@aibees/elephant/hooks/use-save-record';
import { SearchType } from '@aibees/elephant/types';
import { useAuthContext } from '@aibees/shared/auth';
import { useWorkspaceUsers } from '@aibees/shared/workspace';
import { useIsPeopleUnlockButtonLoading } from '../../people-unlock/hooks/use-is-people-unlock-button-loading';
import { doesAiAnalysisHasAnyUpdates } from '../../person-ai-analysis-info/utils';
import { QUICK_INFO_BUTTONS } from '../components/quick-info-button';

export function useHandleEnrichPersonalityAnalysis(
  data?: PeopleTableInfo,
  onSuccess?: () => void
) {
  const { user } = useAuthContext();
  const users = useWorkspaceUsers(true);
  const api = useSaveRecord(SearchType.People);
  const { track } = useTrackEvents();
  const { failed } = usePersonalityAnalysisStatus(api, data);
  const { personalityLoading } = useIsPeopleUnlockButtonLoading(data);
  const { addProcessingItems } = useActionButtonContext();
  const hasUpdates = doesAiAnalysisHasAnyUpdates(data);

  const handleAnalysis = () => {
    if (personalityLoading) return;
    const selectedUser = users.find((u) => u.id === user?.id);
    addProcessingItems({
      id: data?.id ?? '',
      type: QUICK_INFO_BUTTONS.PERSONALITY_ANALYSIS,
      state: hasUpdates
        ? ProcessingItemState.UPDATING
        : ProcessingItemState.UNLOCKING,
    });
    api
      .mutateAsync({
        kind: 'ADD',
        actions: [SaveRecordAction.CONTACT_REVEAL_ANALYSIS],
        ids: [data?.id || ''],
        overwriteOwner: false,
        user: selectedUser,
        labels: [],
      })
      .then(() => {
        track('UNLOCK_PERSONALITY_ANALYSIS', {
          multiple: false,
          retry: failed,
        });
        onSuccess?.();
      });
  };

  return { handleAnalysis, loading: personalityLoading, failed };
}
